import {
  Box,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  VStack,
  Wrap,
} from '@chakra-ui/react';
import { ServiceAdminRole } from '~graphql/__generated__/types';
import { getServiceAdminRoleCategoryLabel } from './serviceAdminRoleCategories';

interface Props {
  value: ServiceAdminRole[];
}

export function ServiceAdminRolesCell({ value: roles }: Props) {
  if (roles.length === 0) {
    return null;
  }

  const [firstRole, ...restRoles] = roles;

  return (
    <Wrap spacing="1" align="center">
      <Text fontSize="sm">{getServiceAdminRoleCategoryLabel(firstRole)}</Text>
      {restRoles.length > 0 && (
        <Popover trigger="hover" placement="top" isLazy>
          <PopoverTrigger>
            <Box
              as="span"
              fontSize="sm"
              color="blue.500"
              border="1px solid"
              borderColor="blue.100"
              borderRadius="md"
              paddingX="2"
              paddingY="0.5"
              cursor="default"
            >
              +{restRoles.length}
            </Box>
          </PopoverTrigger>
          <PopoverContent width="auto" bg="blue.800" borderColor="blue.800">
            <PopoverBody padding="4">
              <VStack align="start" spacing="1">
                {roles.map((role) => (
                  <Text key={role} color="white" fontSize="sm" whiteSpace="nowrap">
                    {getServiceAdminRoleCategoryLabel(role)}
                  </Text>
                ))}
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}
    </Wrap>
  );
}
